<mat-form-field>
    <mat-label class="label" *ngIf="label">{{ label }}</mat-label>   
    <input matInput
          type="text" 
          [placeholder]="placeholder"
          aria-label="arialabelhere"  
          [formControl]="formControl"
          [matAutocomplete]="auto"
          >
    <mat-icon matSuffix class="part2">expand_more</mat-icon>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
      <mat-option *ngIf="showNoneOption">{{ noneOptionLabel | translate }}</mat-option>
      <mat-option *ngFor="let item of filteredItems" [value]="item">
        {{item[displayField]}}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>
